import { render } from "./ConsentForm2.vue?vue&type=template&id=609c4622&scoped=true"
import script from "./ConsentForm2.vue?vue&type=script&lang=js"
export * from "./ConsentForm2.vue?vue&type=script&lang=js"

import "./ConsentForm2.vue?vue&type=style&index=0&id=609c4622&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/ws-frontend-join/ws-frontend-join/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-609c4622"]])

export default __exports__